import { TbRefresh, TbWifiOff } from "react-icons/tb"
import styles from "./UserNotPermission/userNotPermission.module.css"

const PermissionLoadError = ({ onRetry, loading = false }) => (
    <div className={styles.body} role="alert">
        <div className={styles.permissionCard}>
            <div className={styles.iconBadge}><TbWifiOff /></div>
            <div className={styles.copy}>
                <span className={styles.eyebrow}>Falha no carregamento</span>
                <h1>Não foi possível verificar seu acesso</h1>
                <p>Houve uma falha ao carregar os dados da conta ou suas permissões. Verifique sua conexão e tente novamente.</p>
            </div>
            <div className={styles.actions}>
                <button className={styles.secondaryButton} type="button" onClick={onRetry} disabled={loading} aria-busy={loading}>
                    <TbRefresh className={loading ? styles.retrySpinner : undefined} aria-hidden="true" />
                    <span aria-live="polite">{loading ? "Tentando novamente..." : "Tentar novamente"}</span>
                </button>
            </div>
        </div>
    </div>
)

export default PermissionLoadError
